enum AssignTenantModalFragmentEnum {
    AssignTenant = 'AssignTenant',
}

export default AssignTenantModalFragmentEnum;
